import { JsonObject, JsonProperty } from 'json2typescript';

import LegOptionModel from './LegOptionModel';

@JsonObject('LegModel')
export default class LegModel {
  @JsonProperty('id', Number) public id:number = -1;
  @JsonProperty('leg_option', LegOptionModel, true) public legOption:LegOptionModel = undefined;
}
